import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import { Box, Button, Paper, Typography } from '@mui/material';
import React from 'react';

interface Props {
    hasUnsavedChanges: boolean;
    name: string;
    onCancel: () => void;
    onDiscard: () => void;
    onSave: () => void;
    savingProgram: boolean;
}

const ProgramEditorHeader: React.FC<Props> = ({ hasUnsavedChanges, name, onCancel, onDiscard, onSave, savingProgram }) => (
    <Paper sx={{ borderRadius: 3, mb: 3, p: 2.5, position: 'sticky', top: 16, zIndex: 2 }} variant="outlined">
        <Box sx={{ alignItems: { md: 'center', xs: 'stretch' }, display: 'flex', flexDirection: { md: 'row', xs: 'column' }, gap: 1.5, justifyContent: 'space-between' }}>
            <Box>
                <Typography sx={{ fontSize: { md: '1.4rem', xs: '1.2rem' }, fontWeight: 700 }} variant="h4">Editing: {name}</Typography>
                <Typography color="text.secondary" variant="body2">
                    {hasUnsavedChanges ? 'Unsaved changes' : 'Saved'}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 1, justifyContent: { md: 'flex-end', xs: 'stretch' } }}>
                <Button onClick={onCancel} startIcon={<ArrowBackRoundedIcon />} variant="outlined">Back</Button>
                <Button disabled={!hasUnsavedChanges || savingProgram} onClick={onDiscard} variant="text">Discard</Button>
                <Button disabled={savingProgram} onClick={onSave} startIcon={<SaveRoundedIcon />} variant="contained">Save Changes</Button>
            </Box>
        </Box>
    </Paper>
);

export default ProgramEditorHeader;